import styled, { keyframes, css } from 'styled-components';
const continuousSpinningKeyframes = keyframes `
  from {
    transform: rotate(-90deg);
  }
  to {
    transform: rotate(270deg);
  }
`;
const dashLengthFromAngle = (circumference, deg) => `${(deg / 360) * circumference}px`;
const continuousCircularLoadingKeyframes = (circumference) => keyframes `
  0% {
    stroke-dasharray: ${[0, 360]
    .map((d) => dashLengthFromAngle(circumference, d))
    .join(',')};
    stroke-dashoffset: ${dashLengthFromAngle(circumference, 0)};
    // TODO: token needed
    animation-timing-function: ease-in;
  }
  20% {
    stroke-dasharray: ${[200, 360]
    .map((d) => dashLengthFromAngle(circumference, d))
    .join(',')};
    stroke-dashoffset: ${dashLengthFromAngle(circumference, -40)};
  }
  100% {
    stroke-dasharray: ${[200, 360]
    .map((d) => dashLengthFromAngle(circumference, d))
    .join(',')};
    stroke-dashoffset: ${dashLengthFromAngle(circumference, -360)};
  }
`;
const calculateCircumference = (size, strokeWidth) => Math.PI * (size - strokeWidth);
export const StyledProgressIndicator = styled.svg `
  display: block;
  width: ${({ dimensions }) => dimensions}px;
  height: ${({ dimensions }) => dimensions}px;
  transform-origin: 50% 50%;
  animation: ${continuousSpinningKeyframes} 1.5s cubic-bezier(0.4, 0, 0.3, 1)
    infinite;
`;
export const StyledTrack = styled.circle `
  fill: none;
  border: none;
  ${(props) => props.variant === 'inverted'
    ? css `
          stroke: ${props.theme.cmp.color.feedback.progressIndicator.inverted
        .surface.trackLine.default};
        `
    : css `
          stroke: ${props.theme.cmp.color.feedback.progressIndicator.monochrome
        .surface.trackLine.default};
        `}
  stroke-width: 3px;
`;
export const StyledTrain = styled.circle `
  transform-origin: 50% 50%;
  fill: none;
  ${(props) => props.variant === 'inverted'
    ? css `
          stroke: ${props.theme.cmp.color.feedback.progressIndicator.inverted
        .surface.trainLine.default};
        `
    : css `
          stroke: ${props.theme.cmp.color.feedback.progressIndicator.monochrome
        .surface.trainLine.default};
        `}
  stroke-width: 3px;
  animation: ${({ dimensions }) => css `
    ${continuousCircularLoadingKeyframes(calculateCircumference(dimensions, 3)
// TODO: no token
)} 1.5s cubic-bezier(0.3, 0.95, 0.65, 0.9) infinite both
  `};
`;
//# sourceMappingURL=index.styles.js.map